/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemediationSummaryResponse
 */
export interface RemediationSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof RemediationSummaryResponse
     */
    openPOAMCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RemediationSummaryResponse
     */
    overdueTaskCount?: number;
}

/**
 * Check if a given object implements the RemediationSummaryResponse interface.
 */
export function instanceOfRemediationSummaryResponse(value: object): value is RemediationSummaryResponse {
    return true;
}

export function RemediationSummaryResponseFromJSON(json: any): RemediationSummaryResponse {
    return RemediationSummaryResponseFromJSONTyped(json, false);
}

export function RemediationSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemediationSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'openPOAMCount': json['openPOAMCount'] == null ? undefined : json['openPOAMCount'],
        'overdueTaskCount': json['overdueTaskCount'] == null ? undefined : json['overdueTaskCount'],
    };
}

export function RemediationSummaryResponseToJSON(json: any): RemediationSummaryResponse {
    return RemediationSummaryResponseToJSONTyped(json, false);
}

export function RemediationSummaryResponseToJSONTyped(value?: RemediationSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'openPOAMCount': value['openPOAMCount'],
        'overdueTaskCount': value['overdueTaskCount'],
    };
}

